import React from 'react';
type SegmentedProps<T extends string> = {
  label: string;
  value: T;
  options: {
    value: T;
    label: string;
  }[];
  onChange: (value: T) => void;
  size?: 'md' | 'sm';
};
export function Segmented<T extends string>({
  label,
  value,
  options,
  onChange,
  size = 'md'
}: SegmentedProps<T>) {
  return <div role="radiogroup" aria-label={label} className="grid rounded-[6px] border border-pf-line bg-white p-[2px]" style={{
    gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))`
  }} data-id="element-886" data-mp="32yw05lgavf8y">
      
      {options.map(o => <button key={o.value} type="button" role="radio" aria-checked={value === o.value} onClick={() => onChange(o.value)} className={`whitespace-nowrap rounded-[4px] transition-colors duration-150 ${size === 'md' ? 'h-[28px] text-[12.5px]' : 'h-[22px] text-[11.5px]'} ${value === o.value ? 'bg-pf-blue text-white' : 'text-pf-ink hover:bg-pf-panel'}`} data-id="element-887" data-mp="3cuh61uohoznz">
        
          {o.label}
        </button>)}
    </div>;
}